import React from "react";

import { Box, Typography } from "@material-ui/core";

import { useAppSelector } from "store";
import { PartnerFilterStep, selectActiveStep } from "modules/customer/tools/product/partnerFilters/partnerFiltersSlice";

const Title: React.FC = () => {
    const activeStep = useAppSelector(selectActiveStep);

    return (
        <>
            <Typography variant="h5" component="div">
                Product setup
            </Typography>
            <Box paddingTop={1}>
                {activeStep === PartnerFilterStep.SelectPartner && (
                    <Typography variant="subtitle1" component="div">
                        To begin, select a retail partner to explore headroom opportunities and tailor insights to their unique store network. 
                    </Typography>
                )}
                {activeStep === PartnerFilterStep.SelectOperator && (
                    <Typography variant="subtitle1" component="div">
                        Next, select an operator to further refine headroom opportunities across your store network.
                    </Typography>
                )}
            </Box>
        </>
    );
};

export default Title;
